// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/annotations.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, extDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/model/core/annotations.proto.
 */
export const file_proto_model_core_annotations = /*@__PURE__*/
  fileDesc("CiJwcm90by9tb2RlbC9jb3JlL2Fubm90YXRpb25zLnByb3RvEgZjYXJtZW4iOwoOU3RvcmFnZU9wdGlvbnMSEAoIaXNfYXJyYXkYASABKAgSFwoPY29sbGVjdGlvbl9uYW1lGAIgASgJKpEBCgtTdG9yYWdlVHlwZRIcChhTVE9SQUdFX1RZUEVfVU5TUEVDSUZJRUQQABIeChpTVE9SQUdFX1RZUEVfU1VCQ09MTEVDVElPThABEhoKFlNUT1JBR0VfVFlQRV9WRVJTSU9ORUQQAhIoCiRTVE9SQUdFX1RZUEVfVkVSU0lPTkVEX1NVQkNPTExFQ1RJT04QAzpXCgxzdG9yYWdlX3R5cGUSHS5nb29nbGUucHJvdG9idWYuRmllbGRPcHRpb25zGNGGAyABKA4yEy5jYXJtZW4uU3RvcmFnZVR5cGVSC3N0b3JhZ2VUeXBlOmAKD3N0b3JhZ2Vfb3B0aW9ucxIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMY0oYDIAEoCzIWLmNhcm1lbi5TdG9yYWdlT3B0aW9uc1IOc3RvcmFnZU9wdGlvbnNCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_descriptor]);

/**
 * Describes the message carmen.StorageOptions.
 * Use `create(StorageOptionsSchema)` to create a new message.
 */
export const StorageOptionsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_annotations, 0);

/**
 * Describes the enum carmen.StorageType.
 */
export const StorageTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_annotations, 0);

/**
 * StorageType defines how a field should be stored in Firestore
 * Uses bit flags to allow combining types
 *
 * @generated from enum carmen.StorageType
 */
export const StorageType = /*@__PURE__*/
  tsEnum(StorageTypeSchema);

/**
 * Storage type for the field
 *
 * @generated from extension: carmen.StorageType storage_type = 50001;
 */
export const storage_type = /*@__PURE__*/
  extDesc(file_proto_model_core_annotations, 0);

/**
 * Additional storage configuration
 *
 * @generated from extension: carmen.StorageOptions storage_options = 50002;
 */
export const storage_options = /*@__PURE__*/
  extDesc(file_proto_model_core_annotations, 1);

